<template>
    <div class="root" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
        <svg id="first-mask" class="inline-mask" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             :viewBox=getViewBox() xml:space="preserve">
            <polygon class="st0" :points=getPolygonCoordinates()></polygon>
        </svg>
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->
<!--        <p>hello {{ name }}</p>-->

    </div>
</template>

<script>
  // import detectIt from 'detect-it';

  export default {
    name: 'app',
    data() {
      return {
        name: 'Denis',
        intersectionOptions: {
          root: null,
          rootMargin: '0px 0px 0px 0px',
          threshold: [0], // [0.25, 0.75] if you want a 25% offset!
        },
        loaded: false,
        isInView: false,
        scrollDirection: undefined,
        scrollPosition: 0,
        lastScrollPosition: 0,
        // value between 0 - 1
        scrollPositionPercentage: 0,
        parentElem: {
          width: undefined,
          height: undefined,
        },
        window: {
          width: 0,
          height: 0,
        },
        documentHeight: 0,
        polygon: {
          p1: {
            x: 1366,
            y: 0,
            xNew: 1366,
            yNew: 0,
          },
          p2: {
            x: 0,
            y: 250,
            xNew: 0,
            yNew: 250,
          },
          p3: {
            x: 1366,
            y: 250,
            xNew: 1366,
            yNew: 250,
          },
        }
      }
    },
    computed: {
      canvasWidth () {
        return this.window.width;
      },
      canvasHeight () {
        return this.window.height;
      }
    },
    mounted() {
      this.handleResize()
      this.handleScroll()
      // this.setInitialMask()
    },
    updated() {
    },
    created() {
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      onWaypoint ({ going, direction }) {
        // going: in, out
        // direction: top, right, bottom, left
        if (going === this.$waypointMap.GOING_IN) {
            // console.log('is going in');
            this.isInView = true;
        }
        else if (going === this.$waypointMap.GOING_OUT) {
          // console.log('is going out');
          this.isInView = false;
        }
      },
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
        this.documentHeight = document.documentElement.scrollHeight;
        this.setInitialMask();
        this.handleScroll();
      },
      setScrollDirection() {
        if (this.scrollPosition > this.lastScrollPosition){
            this.scrollDirection = 'down';
        } else {
            this.scrollDirection = 'up';
        }
        this.lastScrollPosition = this.scrollPosition <= 0 ? 0 : this.scrollPosition; // For Mobile or negative scrolling
      },
      handleScroll() {
        this.scrollPosition = window.scrollY;
        // found here: https://fabiofranchino.com/blog/scroll-indicator-in-vue/
        if(this.scrollPosition > 0 ) {
            this.scrollPositionPercentage = this.scrollPosition / (this.documentHeight - this.window.height);
        }
        else {
          this.scrollPositionPercentage = 0;
        }
        // console.log(this.scrollPositionPercentage + '% scrolled');
        this.setScrollDirection();
        this.setPolygonCoordinates();
      },

      setInitialMask() {
        this.parentElem.width = this.$el.parentNode.offsetWidth
        this.parentElem.height = this.$el.parentNode.offsetHeight * .25

        const p1 = this.polygon.p1;
        const p2 = this.polygon.p2;
        const p3 = this.polygon.p3;

        p1.xNew = this.parentElem.width;
        p2.yNew = this.parentElem.height;
        p3.xNew = this.parentElem.width;
        p3.yNew = this.parentElem.height;
      },
      setPolygonCoordinates() {
        if (this.isInView) {
          if (this.scrollDirection === 'up') {
            // make sure it height wont get smaller than 0
            if ( this.polygon.p1.yNew > 0 ) {
                this.polygon.p1.yNew = this.polygon.p1.yNew - 1;
            }
          }
          else {
            // make sure height wont get bigger than container element
            if ( this.polygon.p1.yNew < this.parentElem.height ) {
              this.polygon.p1.yNew = this.polygon.p1.yNew + 1;
            }
          }

        }
      },
      getPolygonCoordinates() {
        return `${this.polygon.p1.xNew},${this.polygon.p1.yNew} ${this.polygon.p2.xNew},${this.polygon.p2.yNew} ${this.polygon.p3.xNew},${this.polygon.p3.yNew}`;
      },
      getViewBox() {
        if (typeof this.parentElem.width === 'undefined') return '0 0 0 0';
        return `0 0 ${this.parentElem.width} ${this.parentElem.height}`;
      }
    }
  }
</script>


<style lang="scss" scoped>

    .root {
        /*height: 100%;*/
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: -1px;
    }

    .st0 {
        fill: #ff0000;
    }

</style>
